import { AllowedFormData, createFormData, ensureFormHeader } from '../utils/form';
import { api, ApiRequest, ApiResponse } from '../instance';

export const patchRaw = api.patch;

export async function patchFormRaw<T = any>(
  url: string,
  formData?: FormData | Record<string, AllowedFormData>,
  config: ApiRequest = {},
): Promise<ApiResponse<T>> {
  const postData = formData ? createFormData(formData) : undefined;
  const fullConfig = formData ? ensureFormHeader(config) : config;

  return patchRaw<T>(url, postData, fullConfig);
}

export async function patch<T = any>(
  url: string,
  postData?: any,
  config: ApiRequest = {},
): Promise<T> {
  return (await patchRaw<T>(url, postData, config)).data;
}

export async function patchForm<T = any>(
  url: string,
  formData?: FormData | Record<string, AllowedFormData>,
  config?: ApiRequest,
): Promise<T> {
  return (await patchFormRaw<T>(url, formData, config)).data;
}
